import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./i18n";
import "./index.css";

const CHUNK_RELOAD_KEY = "__chunk_reload_attempted__";

window.addEventListener("error", (e: any) => {
  const isChunkError =
    e?.message
      ?.toLowerCase()
      ?.includes("failed to fetch dynamically imported module") ||
    e?.message?.toLowerCase()?.includes("loading chunk") ||
    e?.message?.toLowerCase()?.includes("importing a module script failed");

  if (!isChunkError) return;

  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;

  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");

  console.log("🔁 Chunk mismatch detected, forcing refresh…");
  window.location.reload();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});
Sentry.init({
  dsn: "https://b018d2b4a05e81441236d0e57b2efc41@o4509485673349120.ingest.us.sentry.io/4510697982132224",
  sendDefaultPii: true, 
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserProfilingIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    "https://instapay-ecommerce.vercel.app",
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.DEV ? "development" : "production",
  beforeSend(event) {
    console.log(event, "Sentry Event");
    if (import.meta.env.DEV) {
      return null;
    }
    return event;
  },
  profilesSampleRate: 1.0,
  defaultIntegrations: false,
  enableLogs: true,
});

createRoot(document.getElementById("root")).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
